import { render, staticRenderFns } from "./MiAsamblea.vue?vue&type=template&id=5effd7a2&scoped=true"
import script from "./MiAsamblea.vue?vue&type=script&lang=js"
export * from "./MiAsamblea.vue?vue&type=script&lang=js"
import style0 from "./MiAsamblea.vue?vue&type=style&index=0&id=5effd7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5effd7a2",
  null
  
)

export default component.exports